import { Search, FileText, Brain, Calculator, Calendar, Sparkles, Check, Loader2 } from 'lucide-react'

const TOOL_ICONS = {
  search: Search,
  extract: FileText,
  research: Brain,
  simulateur_anciennete: Calculator,
  simulateur_rupture: Calculator,
  calendrier: Calendar,
  ragflow: Sparkles,
}

const TOOL_LABELS = {
  search: 'Recherche web',
  extract: 'Extraction de contenu',
  research: 'Recherche approfondie',
  simulateur_anciennete: 'Simulateur ancienneté',
  simulateur_rupture: 'Simulateur rupture',
  calendrier: 'Calendrier concours',
  ragflow: 'Synthèse IA',
}

export default function AgentSteps({ steps, collapsed }) {
  if (!steps || steps.length === 0) return null

  return (
    <div className={`cdg-agent-steps${collapsed ? ' collapsed' : ''}`}>
      {steps.map((step, i) => {
        const Icon = TOOL_ICONS[step.tool] || Sparkles
        const label = TOOL_LABELS[step.tool] || step.tool
        const isDone = step.status === 'done'

        return (
          <div key={i} className={`cdg-agent-step ${step.status}`}>
            <div className="cdg-agent-step-icon">
              {isDone ? <Check size={12} /> : <Loader2 size={12} className="cdg-inline-spinner" />}
            </div>
            <div className="cdg-agent-step-body">
              <span className="cdg-agent-step-label">
                <Icon size={13} />
                {label}
              </span>
              {step.detail && <span className="cdg-agent-step-detail">{step.detail}</span>}
            </div>
          </div>
        )
      })}
    </div>
  )
}
